module.exports = __webpack_public_path__ + "img/2.08.thmb.xs.f0c3163a.jpg";